<template>
    <grid-card is-full :title="$t('dvm_features.solar_panel')">
        <template slot="header">
            <label class="flex-label">
                <h5>{{ $t('valuer_tool.exterior.solar_panel.question') }}</h5>
                <b-checkbox v-model="solar_panel" />
            </label>
        </template>
        <template v-if="solar_panel" slot="default">
            <div class="grid_card-content_grid three-cols">
                <div class="content_grid-item">
                    <b-field :label="$t('dvm_features.solar_panel_area')">
                        <b-input v-model="solar_panel_area" />
                    </b-field>
                </div>
            </div>
        </template>
    </grid-card>
</template>
<script>
import GridCard from '@/apps/Valuation/components/ValuerTool/elements/GridCard'
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'SolarPanels',
    components: {
        GridCard,
    },
    data: () => ({
        solar_panel: false,
        solar_panel_area: 0,
    }),
    computed: {
        ...mapGetters('valuationStore/Address', ['getDVMFeatures']),
    },
    watch: {
        // Debounce everything to not trigger updates on every keystroke
        solar_panel(val) {
            this.SET_DVM_FEATURES({
                solar_panel: val,
            })
        },
        solar_panel_area(val) {
            this.SET_DVM_FEATURES({
                solar_panel_area: val,
            })
        },
    },
    mounted() {
        this.solar_panel = this.getDVMFeatures?.solar_panel || false
        this.solar_panel_area = this.getDVMFeatures?.solar_panel_area || 0
    },
    methods: {
        ...mapMutations('valuationStore/Address', ['SET_DVM_FEATURES']),
    },
}
</script>
